'use client';

import a__default, { memo } from "react";
import { Button } from "../../atoms/Button/Button.js";
import { classNames } from "../../utils/styles/classNames.js";
import { defaultProps } from "./ButtonGroup.defaultProps.js";
import { orientation, dynamic, vertical, horizontalFullWidthOnMobile, horizontal, container, fullHorizontalWrapper } from "./ButtonGroup.css.js";
function ButtonGroupComponent({
  className,
  orientation: orientationProp,
  buttons,
  size: sizeProp,
  onDark = false,
  fullWidthOnMobile
}) {
  const orientation$1 = orientationProp || defaultProps.orientation;
  const size = sizeProp || defaultProps.size;
  const horizontalClassname = fullWidthOnMobile ? horizontalFullWidthOnMobile : horizontal;
  if (buttons.length === 0) return null;
  return /* @__PURE__ */ a__default.createElement(
    "div",
    {
      className: classNames(
        className,
        container,
        orientation$1 === "horizontal" && horizontalClassname,
        orientation$1 === "vertical" && vertical,
        orientation$1 === "dynamic" && dynamic,
        orientation[orientation$1]
      )
    },
    buttons.map((buttonProps) => {
      let { emphasis } = buttonProps;
      if (emphasis === "lowCompact" && buttons.length > 1) {
        emphasis = "low";
      }
      return /* @__PURE__ */ a__default.createElement(
        "div",
        {
          className: classNames(
            fullWidthOnMobile && orientation$1 === "horizontal" && fullHorizontalWrapper
          ),
          key: buttonProps.label
        },
        /* @__PURE__ */ a__default.createElement(
          Button,
          {
            ...buttonProps,
            emphasis,
            fullWidth: fullWidthOnMobile && orientation$1 === "horizontal" || orientation$1 === "vertical" || orientation$1 === "dynamic",
            hiddenLabel: orientation$1 === "horizontal" && buttonProps.hiddenLabel,
            size,
            onDark
          },
          buttonProps.label
        )
      );
    })
  );
}
const ButtonGroup = /* @__PURE__ */ memo(ButtonGroupComponent);
export {
  ButtonGroup
};
